// toggleNegateNode — VQE-Edit edit-action: add / remove `NOT` on the WHERE-tree
// node at `path` (leaf or group). Delegates to SR-Edit `toggle-negate`.

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Toggle negation on the node at `path` (WHERE by default, HAVING with
 * `clause: 'having'`): an explicit group gains / loses a `NOT ` prefix; a leaf
 * or implicit group is wrapped in `NOT (…)`.
 */
export async function toggleNegateNode(
  path: NodePath,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  await commitEdit({ op: 'toggle-negate', path, clause }, ctx);
}
